import { useTranslation } from 'react-i18next'

export function elementsLocked (data, tracking, statusMessage, denunciation, uploadDenunciation) {
  // console.log(data)
  const { t } = useTranslation('dashboardDevice')

  return [
    {
      key: 'keyTouch',
      name: 'keyTouch',
      label: t('lockedDevices.elementsLocked.one'),
      value: data?.touch,
      id: 'touch',
      type: 'checkbox'
    },
    {
      key: 'keyScreen',
      name: 'keyScreen',
      label: t('lockedDevices.elementsLocked.two'),
      value: data?.screen,
      id: 'screen',
      type: 'checkbox'
    },
    {
      key: 'keyBackground',
      name: 'keyBackground',
      label: t('lockedDevices.elementsLocked.three'),
      value: data?.background,
      id: 'background',
      type: 'checkbox'
    },
    {
      key: 'keyAlarm',
      name: 'keyAlarm',
      label: t('lockedDevices.elementsLocked.four'),
      value: data?.alarm,
      id: 'alarm',
      type: 'checkbox'
    },
    {
      key: 'keyStatusMessage',
      name: 'keyStatusMessage',
      label: t('lockedDevices.elementsLocked.five'),
      value: statusMessage,
      id: 'statusMessage',
      type: 'checkbox'
    },
    {
      key: 'keyMessageTitle',
      name: 'keyMessageTitle',
      label: t('lockedDevices.elementsLocked.six'),
      display: statusMessage,
      value: data?.messageTitle,
      id: 'messageTitle',
      type: 'text'
    },
    {
      key: 'keyMessageBody',
      name: 'keyMessageBody',
      label: t('lockedDevices.elementsLocked.seven'),
      display: statusMessage,
      value: data?.messageBody,
      id: 'messageBody',
      type: 'area'
    },
    {
      key: 'keyTracking',
      name: 'keyTracking',
      label: t('lockedDevices.elementsLocked.eight'),
      value: tracking?.statusTracking,
      id: 'statusTracking',
      type: 'checkbox'
    },
    {
      key: 'keyTrackingTrack',
      name: 'keyTrackingTrack',
      display: tracking?.statusTracking,
      label: t('lockedDevices.elementsLocked.nine'),
      small: t('lockedDevices.elementsLocked.ten'),
      value: tracking?.tracking,
      id: 'tracking',
      type: 'number'
    },
    {
      key: 'keyReportTracking',
      name: 'keyReportTracking',
      display: tracking?.statusTracking,
      label: t('lockedDevices.elementsLocked.eleven'),
      small: t('lockedDevices.elementsLocked.ten'),
      value: tracking?.report,
      id: 'report',
      type: 'number'
    },
    {
      key: 'keyDenunciation',
      name: 'keyDenunciation',
      label: t('lockedDevices.elementsLocked.twelve'),
      value: uploadDenunciation,
      id: 'denunciation',
      type: 'checkbox'
    },
    {
      key: 'keyIncidentDate',
      name: 'keyIncidentDate',
      label: t('lockedDevices.elementsLocked.thirteen'),
      display: uploadDenunciation,
      value: denunciation?.incidentDate,
      id: 'incidentDate',
      type: 'date'
    },
    {
      key: 'keyDenunciationDate',
      name: 'keyDenunciationDate',
      label: t('lockedDevices.elementsLocked.fourteen'),
      display: uploadDenunciation,
      value: denunciation?.denunciationDate,
      id: 'denunciationDate',
      type: 'date'
    },
    {
      key: 'keyDenunciationNumber',
      name: 'keyDenunciationNumber',
      label: t('lockedDevices.elementsLocked.fifteen'),
      display: uploadDenunciation,
      value: denunciation?.denunciationNumber,
      id: 'denunciationNumber',
      type: 'text'
    },
    {
      key: 'keyInvestigator',
      name: 'keyInvestigator',
      label: t('lockedDevices.elementsLocked.sixteen'),
      display: uploadDenunciation,
      value: denunciation?.investigator,
      id: 'investigator',
      type: 'text'
    }
    // ,
    // {
    //   key: 'keyPhotoStatus',
    //   name: 'keyPhotoStatus',
    //   label: 'Generar imagenes',
    //   value: data.photo.status,
    //   id: 'status',
    //   type: 'checkbox'
    // },
    // {
    //   key: 'keyRecursive',
    //   name: 'keyRecursive',
    //   display: data.photo.status === true,
    //   label: 'Recursivo',
    //   value: data.photo.recursive,
    //   id: 'recursive',
    //   type: 'checkbox'
    // },
    // {
    //   key: 'keyPhotoTime',
    //   name: 'keyPhotoTime',
    //   display: data.photo.status === true && data.photo.recursive === true,
    //   label: 'Intervalo de imagenes',
    //   small: '(en minutos)',
    //   value: data.photo.time,
    //   id: 'time',
    //   type: 'number'
    // },
    // {
    //   key: 'keyPhotoQuality',
    //   name: 'keyPhotoQuality',
    //   display: data.photo.status === true,
    //   label: 'Resolucion de imagenes: ',
    //   value: data.photo.quality,
    //   id: 'quality',
    //   type: 'options',
    //   default: 'Seleccione la calidad de imagen',
    //   options: [
    //     {
    //       value: 'high',
    //       title: 'Alto'
    //     },
    //     {
    //       value: 'mid',
    //       title: 'Medio'
    //     },
    //     {
    //       value: 'low',
    //       title: 'Bajo'
    //     }
    //   ]
    // }
  ]
}
